import { render } from "./LoginHelp.vue?vue&type=template&id=3fbc21a0&scoped=true&class=login-wrapper"
import script from "./LoginHelp.vue?vue&type=script&lang=js"
export * from "./LoginHelp.vue?vue&type=script&lang=js"

import "./LoginHelp.vue?vue&type=style&index=0&id=3fbc21a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbc21a0"]])

export default __exports__